import { FC } from 'react';

import { t } from '@onlinepayments/payments-library';

import loadingAnimation from './loading-animation.gif';

import './Loader.scss';

interface ILoaderProps {
  className?: string;
}

const Loader: FC<ILoaderProps> = ({ className = '' }) => {
  return (
    <div data-testid="Loader" className={`ikea-loader ${className}`}>
      <img
        className="ikea-loader__image theme-dark-rounded-image"
        src={loadingAnimation}
        alt={t('loading_animation_alt_text')}
      />
    </div>
  );
};

export default Loader;
